export const calcProgress = (count: number, total: number) => {
  return Math.round(total === 0 ? 0 : count * 100 / total)
}
